import { SETTINGS } from '../setup/config';

import Intro from '../components/Intro';
import AnimatedPage from './AnimatedPage';
import ContentBlocks from '../components/ContentBlocks';
import ContentBlock from '../components/ContentBlock';
import ContentSimple from '../components/ContentSimple';
import PhotoBlock from '../components/PhotoBlock';
import AnimatedImage from '../components/assets/AnimatedImage';
import Separator from '../components/Separator';

import Button from '../components/Button';
import { ButtonTypes } from '../setup/enum-buttontypes';

import IconLinkedin from '../components/assets/IconLinkedin';

function Overmij() {
	return (
		<AnimatedPage title={'Over mij'}>
			<Intro title="Ik ben Jolanda, dierenarts voor gezelschapsdieren" text="Al van jongs af aan wist ik dat ik 'iets met dieren' wilde gaan doen. Al gauw werd dat 'ik wil dierenarts worden'." logo={false} buttonText="Lees verder" hideButtonMobile={true} />
			<Separator logo={false} type={1} />
			<ContentBlocks>
				<div className="columnlayout__column offset1">
					<ContentBlock
						className="contentblocks__contentblock1  contentblock--white"
						button={<Button newTab={true} link={SETTINGS.linkedin} text={'Volg mij'} icon={<IconLinkedin />} type={ButtonTypes.ButtonIcon} />}
						content={
							<>
								<p>
									In 2015 ben ik afgestudeerd als <strong>Dierenarts voor gezelschapsdieren aan de Faculteit Diergeneeskunde</strong> van de Universiteit Utrecht. Ik heb sindsdien bij verschillende dierenartspraktijken in Noord-Holland gewerkt en waarnemingen gedaan. Tevens heb ik een periode buiten
									de praktijk gewerkt voor een dierenwelzijnsorganisatie.
								</p>
							</>
						}
					/>
					<PhotoBlock className="photoblock__photoblock2" />
				</div>
				<div className="columnlayout__column">
					<ContentBlock
						className="contentblocks__contentblock2 contentblock--white"
						image={<AnimatedImage />}
						content={
							<>
								<p>
									Mensen omschrijven mij als empathisch, gedreven, leergierig en een harde werker. Ik help graag, ben betrokken en zorgzaam. Ik werk zorgvuldig en graag samen met baasje en dier om tot de beste zorg te komen. Op deze manier zet ik mij met een{' '}
									<strong>holistische visie, vol passie en aandacht</strong> in voor de (preventieve) gezondheid van onze harige viervoeters en hun baasjes.
								</p>
							</>
						}
					/>
					<ContentBlock
						className="contentblocks__contentblock2"
						content={
							<>
								<p>Ik woon in Heemskerk, Noord-Holland, samen met mijn man, de twee liefste zoontjes, twee blije hondjes Milow en Xavi en de twee konijntjes Zus en Lukas.</p>
							</>
						}
					/>
				</div>
				
			</ContentBlocks>
			<ContentSimple
						className="contentsimple--light"
						content={
							<>
								<h2>Opleidingen</h2>

								<ul className="nm nl">
									<li>
										Diergeneeskunde, Faculteit Diergeneeskunde, Universiteit Utrecht (2015) <br />
										<span className="text--opaque">Studierichting Gezelschapsdieren, Master Bestuur & Beleid</span>
									</li>
									<li>Veterinaire osteopathie, Supple Spine Institute (2020)</li>
									<li>Veterinaire chiropractie, Supple Spine Institute (2022)</li>
									<li>Animal Fascia Manipulation, niveau I, Tuulia Luomala & Mika Pihlman (2023)</li>
									<li>Animal Fascia Manipulation, niveau II, Tuulia Luomala & Mika Pihlman (2024)</li>
									<li>Orthomoleculaire Therapie voor honden, Ingrid Smolders (Into The Wild) & Eve Verstappen (Wildebeest Coaching) (2024)</li>
									<li>Orthomoleculaire Therapie voor katten, basis- en vervolgopleiding, Eve Verstappen (Wildebeest Coaching) (2025)</li>
									<li>Filmgeneeskunde voor honden, Véronique van Haegenborgh (Viventi / Sunoré) (2025-2026)</li>
								</ul>
								<p className="text-left">Daarnaast heb ik ervaring opgedaan met homeopathie, Bachbloesems, Integrative Manual Therapy en lasertherapie. Ik volg regelmatig (online) nascholingen om mijn kennis up-to-date te houden. </p>
								<p className="text-left">
									<small>
									Let op: op dit moment (2026) ben ik beschikbaar voor orthomoleculaire voedingsadviezen, (reguliere) consulten en werkzaamheden binnen een dierenartspraktijk (beperkt tot aug. 2026). Ik neem momenteel geen aanvragen aan voor manuele therapieën.</small>
								</p>
							</>
						}
					/>
			<ContentSimple
				content={
					<>
						<p>Als je op zoek bent naar een holistisch werkend dierenarts of advies wilt over voeding, orthomoleculaire suppletie, een passende behandeling, of andere vormen van ondersteuning voor jouw huisdier, aarzel dan niet om vrijblijvend contact met mij op te nemen via e-mail.</p>
					</>
				}
				button={<Button className="button--main" link={'/contact'} text={'Maak een afspraak'} type={ButtonTypes.ButtonIcon} />}
			/>
		</AnimatedPage>
	);
}

export default Overmij;
